import { MyFirmListItem } from "@/lib/types";

const FIRM_KEY = "firm";

export const storeFirm = (firm: MyFirmListItem) => {
  localStorage.setItem(FIRM_KEY, JSON.stringify(firm));
};

export const getFirm = () => {
  if (!localStorage.getItem(FIRM_KEY)) {
    return undefined;
  }

  return JSON.parse(localStorage.getItem(FIRM_KEY) ?? "{}");
};

export const removeFirm = () => {
  localStorage.removeItem(FIRM_KEY);
};
